<template>
  <div class="baoxiu_list">
    <div class="header">
      <el-input placeholder="请输入手机号" style="width: 74%;" v-model="form.mobNo" type="text"/>
      <el-button type="primary" @click="getList" style="width: 20%;">查询</el-button>
      <p class="redText">注：输入手机号可查询入网申请列表</p>
    </div>
    <section>
      <li class="baoxiu_item" v-for="(item, ind) in list" :key="ind" >
        <p class="baoxiu_flex">
                <span>
                    姓名: {{$formatName(item.name)}}
                </span>
         <span :class="getColor(item.shzt)">
              {{item.shzt}}
          </span>
        </p>
        <p class="baoxiu_flex">
            <span>
                手机号：{{formatNumber(item.mobNo)}}
            </span>
        </p>
        <p class="baoxiu_flex">
            <span>
                身份证号：{{formatNumber(item.idNumber, 6, 4)}}
            </span>
        </p>
        <p class="baoxiu_flex">
            <span>
                面积：{{item.jzmj}} m²
            </span>
        </p>
        <p class="baoxiu_flex">
          <span>
              小区：{{item.three}}
          </span>
        </p>
        <p class="baoxiu_flex">
          <span>
              地址：{{item.address}}
          </span>
        </p>
      </li>
      <p class="no_data" v-if="!list.length">
        暂无业务记录
      </p>
    </section>

  </div>
</template>

<script>
  import {findRwshLog, getYwjl} from '@/api'
  import {validSlsx, formatNumber, getQueryVariable} from "@/utils";
  export default {
    data() {
      return {
        companyCode: sessionStorage.getItem("companyCode"),
        list: [],
        value: '',
        taskTypeOptioon:[
          {value:'报修',label:'报修'},
          {value:'投诉',label:'投诉'},
          {value:'建议',label:'建议'},
          {value:'测温',label:'测温'},
        ],
        form: {},
        rules:{}
      }
    },
    mounted() {
      if (!this.companyCode || !this.thirdId) {
        var companyCode = getQueryVariable("state");
        var code = getQueryVariable("code");
        if (companyCode.indexOf("#") > -1) {
          companyCode = companyCode.split("#")[0];
        }
        sessionStorage.setItem("state", companyCode);
        sessionStorage.setItem("companyCode", companyCode);
      }
      if(this.$route.query.mobNo) {
        this.form.mobNo = this.$route.query.mobNo
        this.getList()
      }
    },
    methods: {
      formatNumber,
      getList(){
        if(!this.form.mobNo) {
          this.$toast('请输入手机号查询')
          return
        }
        this.form.companyCode = sessionStorage.getItem("companyCode")
        findRwshLog(this.form).then(res=> {
          this.list = res.data
        })
      },
      getValue(status) {
        let arr = ['待处理', '处理中', '待评价','', '已完成']
        return arr[status]
      },
      goPj(ordersn) {
        this.$router.push({
          path: '/pj',
          query: {
            ordersn: ordersn
          }
        })
      },
      getColor(type) {
        let className = 'text_green'
        if(type=='审核中') {
          className = 'text_orange'
        } else if(type=='未通过') {
          className = 'text_red'
        }

        return className
      },
      goBx() {
        if(validSlsx('停供')){
          this.$router.push({
            path: '/changeStatus',
            query: this.$route.query
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">

  .baoxiu_list{
    display:-webkit-box;
    display:-webkit-flex;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-flex-direction:column;
    -ms-flex-direction:column;
    flex-direction:column;
    width:100%;
    height:90%;
    .header{
      width: 100%;
      padding: 10px 3%;
      background: #fff;
      border-bottom: 1px solid #F7F6F7;
    }

    .redText {
      color: red;
      font-size: 12px;
      margin-top: 5px;
    }
  }
  .demo-ruleForm{
    margin-top: 5px;
    margin-left: 10px;
  }
  .btn_bx{
    width: 94%;
    margin-left: 3%;
    /*margin-top: 3rem;*/
    font-size: 1rem;
    height: 2.5rem;
    background: #47c34d;
    border-radius: 3px;
  }
  .text_green{
    color: #47c34d;
  }
  .text_red{
    color: red;
  }
  .text_orange{
    color:orange;
  }
  header,footer{
    height:40px;
    line-height: 40px;

    /*text-align:center;*/
  }
  header{
    margin-bottom: 5px;
    background-color:#fff;

  }
  section{
    -webkit-box-flex:1;
    -webkit-flex:1;
    -ms-flex:1;
    flex:1;
    width:100%;
    overflow:auto;/* winphone8和android4+ */
    -webkit-overflow-scrolling: touch; /* ios5+ */
  }

  .baoxiu_item{
    border-bottom: 5px solid #f1f1f1;
    padding: 3%;
    line-height: 25px;
    background: #fff;
  }
  .baoxiu_flex{
    display: flex;
    justify-content: space-between;
  }
  .goPj{
    color: #1890ff;
  }

</style>



// WEBPACK FOOTER //
// src/view/ywbl/rwsq/rwList.vue